import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    shipment: any;
    order?: OrderModel;
}

type Props = OwnProps;

export interface ADIOrderDetailsProgressBarStyles {
    mainContainer?: InjectableCss;
}

export const adiOrderDetailsProgressBarStyles: ADIOrderDetailsProgressBarStyles = {
    mainContainer: {
        css: css`
        &.rd-orders-details-landing{
            width: 100%;
        }
        @media print {
            &.rd-orders-details-landing .progress-bar-with li {
                list-style-type: none;
                float: left !important;
                width: 30% !important;
            }
        
            &.rd-orders-details-landing .progress-bar-with {
                width: 100% !important;
                list-style: none;
                list-style-image: none;
            }
        }
        @media only screen and (min-width: 768px) and (max-width: 1080px) {
            &.rd-orders-details-landing{
                .orderdetail-progress-bar{
                    margin-bottom: 13px;
                    ol.progress-bar-with {
                        margin-left: -22px;
                    }
                    li {
                        min-width: 208px;
                    }
                }
                .mobileProgressBar{
                    display: none;
                }
                .progress-bar-with {
                    .bar-status-active .status-address {
                        margin-top: 2px;
                    }
                    .status-address {
                        margin-top: 1px;
                    }
                    margin-left: -20px;
                    padding-top: 26px;
                    .step:after {
                        bottom: 53px !important;
                    }
                }
            }
        }
        @media only screen and (max-width: 767px) {
            &.rd-orders-details-landing{
                .orderdetail-progress-bar {
                    padding-top: 25px;
                    clear: both;
                    border-top: 1px solid ${getColor("common.border")};
                }
                .desktopProgressBar{
                    display: none;
                }
                .mobile-bar-content {
                    width: 80%;
                    position: relative;
                    left: 40px;
                    .status-address{
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.43;
                        letter-spacing: normal;
                        color: ${getColor("text.main")};
                        .date-status{
                            margin-bottom: 2px;
                        }
                    }
                }
                .progress-bar-with{
                    .bar-status-active .step {
                        background-image: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/icon-success.svg);
                        height: 24px !important;
                        width: 24px !important;
                        background-repeat: no-repeat;
                        position: relative;
                        left: -4px;
                        background-color: transparent !important;
                    }
                    width: 100%;
                    list-style: none;
                    list-style-image: none;
                    margin: 0 0 12px 0;
                    padding: 3px 2px 0px 8px;
                    li {
                        padding-left: 24px;
                        height: 70px;
                    }
                    .bar-status-active {
                        .name {
                            font-size: 14px;
                            font-weight: bold;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.14;
                            letter-spacing: normal;
                            text-align: left;
                            color: ${getColor("text.main")};
                            opacity: 1;
                            left: -24px;
                        }
        
                        .status-address .date-status {
                            position: relative;
                            left: -24px;
                        }
                    }
                    .name {
                        display: block;
                        vertical-align: bottom;
                        margin-bottom: 0px;
                        font-size: 14px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.14;
                        letter-spacing: normal;
                        text-align: left;
                        color: ${ADIColors.gray3};
                        position: relative;
                        left: -15px;
                        margin-bottom: 2px;
                    }
                    .bar-status-active .status-address {
                        font-size: 14px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.43;
                        letter-spacing: normal;
                        color: ${getColor("text.main")};
                    }
                    .step {
                        color: black;
                        border: 4px solid ${ADIColors.gray3};
                        background-color: ${ADIColors.gray3};
                        border-radius: 50%;
                        line-height: 1.2;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        z-index: 0;
                    }
                    .step.name {
                        opacity: 0.3;
                    }
                    .name.od {
                        opacity: 1;
                        position: relative;
                    }
                    .active {
                        .name, .step span {
                            opacity: 1;
                        }
                    }
                    .step:after {
                        content: "";
                        display: block;
                        background-color: ${ADIColors.gray3};
                        height: 75px;
                        width: 4px;
                        margin-left: 5px;
                    }
                    li:last-of-type .step:after {
                        display: none;
                    }
                    .done .step {
                        background-color: ${ADIColors.lightGreen1};
        
                        &:after {
                            background-color: ${ADIColors.lightGreen1};
                        }
                    }
                    .active .step {
                        background-color: ${ADIColors.lightGreen1};
                    }
                    .done .step, .active .step, .pending .step {
                        border: none;
                        height: 15px;
                        width: 15px;
                        margin-bottom: -1px;
                        float: left;
                    }
                    .active .step {
                        background: ${getColor("common.background")};
                        height: 24px;
                        width: 24px;
        
                        img {
                            height: 24px;
                            width: 24px;
                            margin-bottom: 3px;
                        }
                    }
                    li span {
                        &.name {
                            font-size: 14px;
                            font-weight: bold;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.14;
                            letter-spacing: normal;
                            color: ${getColor("text.main")};
                            padding-bottom: 9px;
                        }
        
                        &.od, &.address {
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.14;
                            letter-spacing: normal;
                            text-align: center;
                            color: ${getColor("text.main")};
                        }
        
                        &.od {
                            padding-bottom: 0;
                            top: 2px;
                        }
                    }
                }
            }
        }
        @media only screen and (min-width: 768px) {
            &.rd-orders-details-landing .progress-bar-with .bar-status-active .status-address .date-status {
                margin-top: -6px;
            }
            &.rd-orders-details-landing {
                ol.progress-bar-with[data-steps="2"] li {
                    width: 20%;
                }
                .mobileProgressBar{
                    display: none;
                }
                .progress-bar-with {
                    .bar-status-active .step {
                        &:before {
                            bottom: 59px;
                        }
    
                        background-image: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/icon-success.svg);
                        height: 24px !important;
                        width: 24px !important;
                        background-repeat: no-repeat;
                        background-color: transparent !important;
                    }
    
                    .status-address {
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.43;
                        letter-spacing: normal;
                        text-align: center;
                        color: ${getColor("text.main")};
                    }
                }
    
                ol.progress-bar-with {
                    &[data-steps="3"] li, &[data-steps="4"] li, &[data-steps="5"] li {
                        width: 20%;
                    }
                }
    
                .progress-bar-with {
                    width: 100%;
                    list-style: none;
                    list-style-image: none;
                    margin: 0px 0 20px 0;
                    padding: 0;
                    margin-left: -35px;
    
                    li {
                        float: left;
                        text-align: center;
                        position: relative;
                        max-width: 224px;
                    }
    
                    .bar-status-active .name {
                        font-size: 14px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.14;
                        letter-spacing: normal;
                        text-align: center;
                        color: ${getColor("text.main")};
                        opacity: 1;
                    }
    
                    .name {
                        display: block;
                        vertical-align: bottom;
                        margin-bottom: 0px;
                        font-size: 14px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.14;
                        letter-spacing: normal;
                        text-align: center;
                        color: ${ADIColors.gray3};
                        margin-bottom: 5px;
                    }
    
                    .step {
                        color: black;
                        border: 4px solid ${ADIColors.gray3};
                        background-color: ${ADIColors.gray3};
                        border-radius: 50%;
                        line-height: 1.2;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        z-index: 0;
                    }
                }
    
                .orderdetail-progress-bar {
                    display: inline-block;
                    width: 100%;
                    margin-bottom: 13px;
                }
    
                .progress-bar-with {
                    .step.name {
                        opacity: 0.3;
                    }
                    .name.od {
                        opacity: 1;
                        position: relative;
                    }
                    .active {
                        .name, .step span {
                            opacity: 1;
                        }
                    }
                    .step {
                        &:before {
                            content: "";
                            display: block;
                            background-color: ${ADIColors.gray3};
                            height: 4px;
                            width: 50%;
                            position: absolute;
                            bottom: 52px;
                            left: 0;
                            display: none;
                        }
                        &:after {
                            content: "";
                            display: block;
                            background-color: ${ADIColors.gray3};
                            height: 4px;
                            width: 100%;
                            position: absolute;
                            bottom: 52px;
                            right: 0;
                            left: 50%;
                        }
                    }
                    li {
                        &:first-of-type .step:before, &:last-of-type .step:after {
                            display: none;
                        }
                    }
                    .done .step {
                        background-color: ${ADIColors.lightGreen1};
                        height: 4px;
                        &:before, &:after {
                            background-color: ${ADIColors.lightGreen1};
                            height: 4px;
                        }
                    }
                    .active .step {
                        background-color: ${ADIColors.lightGreen1};
                        height: 4px;
                        &:before {
                            background-color: ${ADIColors.lightGreen1};
                            height: 4px;
                        }
                    }
                    .done .step, .active .step, .pending .step {
                        border: none;
                        height: 15px;
                        width: 15px;
                        margin-bottom: -1px;
                    }
                }
                .progress-bar-with {
                    .active .step {
                        background: ${getColor("common.background")};
                        height: 24px;
                        width: 24px;
                        img {
                            height: 24px;
                            width: 24px;
                            margin-bottom: 3px;
                        }
                    }
                    .done {
                        &.Shipped .step {
                            &::after, &::before {
                                bottom: 51px;
                                height: 4px;
                            }
                        }
                        &.Transit .step {
                            &::after, &::before {
                                bottom: 51px;
                                height: 4px;
                            }
                        }
                    }
    
                    .bar-status-active .status-address {
                        font-size: 14px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.43;
                        letter-spacing: normal;
                        text-align: center;
                        color: ${getColor("text.main")};
                    }
                    li span {
                        &.name {
                            font-size: 14px;
                            font-weight: bold;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.14;
                            letter-spacing: normal;
                            text-align: center;
                            color: ${getColor("text.main")};
                            padding-bottom: 9px;
                        }
                        &.od, &.address {
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.14;
                            letter-spacing: normal;
                            text-align: center;
                            color: ${getColor("text.main")};
                        }
                        &.od {
                            padding-bottom: 0;
                            top: 2px;
                        }
                    }
                }
            }
        }
        `
    }
};

const styles = adiOrderDetailsProgressBarStyles;

const ADIOrderDetailsProgressBar: FC<Props> = ({ shipment, order }) => {
    return (
        <>
            {shipment?.trackingList.length > 0 && order?.properties?.isLTL !== 'Y' && (
                <StyledWrapper {...styles.mainContainer} className="rd-orders-details-landing">
                    <StyledWrapper className="orderdetail-progress-bar">
                        <StyledWrapper className="progress-tracking">
                            <ol className="desktopProgressBar progress-bar-with" data-steps={`${shipment?.trackingList[0]?.shipActivities.length}`}>
                                {shipment?.trackingList[0]?.shipActivities.map((record: any) => <>
                                    <li className={`done ${record.statusText === 'Delivered' ? 'bar-status-active' : ''}`}>
                                        <StyledWrapper className="name"> {record?.statusText}</StyledWrapper>
                                        <StyledWrapper className="step"> </StyledWrapper>
                                        <StyledWrapper className="status-address">
                                            <StyledWrapper className="date-status"> {record?.statusDateFormatted}</StyledWrapper>
                                            <StyledWrapper className="location-status">{record?.statusLocation}</StyledWrapper>
                                        </StyledWrapper>
                                    </li>
                                </>)}
                            </ol>
                            <ol className="mobileProgressBar progress-bar-with" data-steps={`${shipment?.trackingList[0]?.shipActivities.length}`}>
                                {shipment?.trackingList[0]?.shipActivities.map((record: any) => <>
                                    <li className={`done ${record.statusText === 'Delivered' ? 'bar-status-active' : ''}`}>
                                        <StyledWrapper className="step"> </StyledWrapper>
                                        <StyledWrapper className="mobile-bar-content">
                                            <StyledWrapper className="name"> {record?.statusText}</StyledWrapper>
                                            <StyledWrapper className="status-address">
                                                <StyledWrapper className="date-status"> {record?.statusDateFormatted}</StyledWrapper>
                                                <StyledWrapper className="location-status">{record?.statusLocation}</StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </li>
                                </>)}
                            </ol>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </>
    )
};

export default ADIOrderDetailsProgressBar;
